// extracted by mini-css-extract-plugin
export default {"BlogGrid":"XDEMB9P73qwZ1wldnaI_"};